exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"ConstructionDocumentTab.vue","sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=_v-1a2d7cca&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./resources/assets/javascript/components/construction/Modal/ConstructionDocumentTab.vue
// module id = ./node_modules/css-loader/index.js?sourceMap!./node_modules/vue-loader/lib/style-rewriter.js?id=_v-1a2d7cca&scoped=true!./node_modules/vue-loader/lib/selector.js?type=style&index=0!./resources/assets/javascript/components/construction/Modal/ConstructionDocumentTab.vue
// module chunks = 54